import confirmTemplate from './confirm-modal.html';

export class ConfirmModal {
  constructor($uibModalInstance, title, messages, confirmLabel, confirmClass, onConfirm) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.title = title;
    this.messages = messages;
    this.confirmLabel = confirmLabel;
    this.confirmClass = confirmClass;
    this.onConfirm = onConfirm;
    this.message = '';
    this.processing = false;
  }
  cancelClicked() {
    this.$uibModalInstance.dismiss();
  }

  confirmClicked() {
    this.processing = true;
    this.onConfirm((progressMessage) => {
      this.message = progressMessage;
    })
      .then(() => {
        this.processing = false;
        this.$uibModalInstance.close();
      })
      .catch((message) => {
        this.processing = false;
        this.message = message;
      });
  }
}

export function Confirm({ $uibModal, title, messages, confirmLabel, confirmClass, onConfirm }) {
  return $uibModal.open({
    animation: true,
    size: 'sm',
    backdrop: 'static',
    keyboard: false,
    template: confirmTemplate,
    controller: ConfirmModal,
    controllerAs: 'modalVM',
    resolve: {
      title: () => title,
      messages: () => messages,
      confirmLabel: () => confirmLabel,
      confirmClass: () => confirmClass || '',
      onConfirm: () => onConfirm,
    },
  }).result;
}

export function ConfirmDelete({ $uibModal, title, messages, onConfirm }) {
  return Confirm({
    $uibModal,
    title,
    messages,
    confirmLabel: 'Delete',
    confirmClass: 'btn-danger',
    onConfirm,
  });
}
